import { Operator } from '@/modules/corporate/modules/database/fields/types';
import {
  getEmptyFieldValue,
  getFilterFieldValue,
} from '@/modules/corporate/modules/database/fields/utils/operators';
import { FilterOperatorEnum } from '@/types/schema';

const NumberOperators: Operator[] = [
  {
    labelKey: 'Database:Operators.Equal',
    value: FilterOperatorEnum.Equal,
    getFieldValue: getFilterFieldValue,
  },
  {
    labelKey: 'Database:Operators.NotEqual',
    value: FilterOperatorEnum.NotEqual,
    getFieldValue: getEmptyFieldValue,
  },
  {
    labelKey: 'Database:Operators.LessThan',
    value: FilterOperatorEnum.LessThan,
    getFieldValue: ({ filterValue }) =>
      filterValue && Number(filterValue) ? String(Number(filterValue) - 1) : '',
  },
  {
    labelKey: 'Database:Operators.LessThanEqual',
    value: FilterOperatorEnum.LessThanEqual,
    getFieldValue: getFilterFieldValue,
  },
  {
    labelKey: 'Database:Operators.GreaterThan',
    value: FilterOperatorEnum.GreaterThan,
    getFieldValue: ({ filterValue }) =>
      filterValue && Number(filterValue) ? String(Number(filterValue) + 1) : '',
  },
  {
    labelKey: 'Database:Operators.GreaterThanEqual',
    value: FilterOperatorEnum.GreaterThanEqual,
    getFieldValue: getFilterFieldValue,
  },
];

export default NumberOperators;
